import React, {useEffect} from 'react';
import "./notify-me.scss";
import BuyBeltInit from '../../shims/buy-belt-init';

function NotifyMe({
  fulfillmentDetails
}) {
  useEffect(() => {
      BuyBeltInit.initTrackIf();
    }, []
  );

  const {
    storeName,
    doNotifyMe,
    doNotifyMeOosSharedOnly,
    doNotifyMeOosStoreOnly,
    doNotifyMeOosOnlineOnly,
    showNotifyBox,
    discontinuedItem
  } = fulfillmentDetails;

  const discontinued =
          <div className="alert-inline alert-inline--danger">
              <span className="alert-inline__message">
                  <span className="alert-inline__title">Discontinued! </span>
                  We are no longer carrying this particular product.
              </span>
          </div>;

  const howToGetItBox =
    <div className="notify-me__title-box">
      How To Get It
    </div>;

  const oosOnlineMessage =
    <div className="oos-online notify-me__danger">
      This item is currently out of stock
    </div>;

  const unvailableDeliveryMessage =
    <div className="unavailable-online">
      {`Delivery is `}
      <span className="notify-me__danger">unavailable</span>
      {` for this item.`}
    </div>;

  const oosSharedMessage =
    <div className="oos-online-shared notify-me__danger">
      Out of stock online
    </div>;

  const checkNearbyStores =
    <a href="#" className="store-inventory-finder-trigger">Check Nearby Stores</a>;

  const notifyMeDescription =
    <div>
      <div>
        {`This item is `}
        <span className="notify-me__danger notify-me__unavailable-at-store">unavailable</span>
        {` at ${storeName}`}
      </div>
      {checkNearbyStores}
      {doNotifyMeOosSharedOnly && oosSharedMessage}
      {doNotifyMeOosStoreOnly && unvailableDeliveryMessage}
    </div>;

  const notifyMeBox =
    <div className="notifyMe_tagline">
      Receive an email when it’s back in stock:
      <div className="notifyMe_spaceBetween">
        <form id="trackif_form">
          <div id="trackif" className="trackif"/>
        </form>
      </div>
    </div>;

  const showNotifyMeDescription =
    !doNotifyMeOosOnlineOnly &&
    (doNotifyMeOosSharedOnly || doNotifyMeOosStoreOnly) &&
    !discontinuedItem;

  const showNotifyEmail =
    !doNotifyMeOosStoreOnly &&
    (doNotifyMeOosSharedOnly || doNotifyMeOosOnlineOnly || doNotifyMe) &&
    !discontinuedItem;

  const showOosOnlineMessage =
    doNotifyMeOosOnlineOnly &&
    !discontinuedItem;

  return showNotifyBox ? (
    <div className={"notify-me__border"} >
      {howToGetItBox}
      {showNotifyMeDescription && notifyMeDescription}
      {showOosOnlineMessage && oosOnlineMessage}
      {showNotifyEmail && notifyMeBox}
      {discontinuedItem && discontinued}
    </div>
  ) : null;
}

export default NotifyMe;
